import 'assets/css/material-dashboard-react.css?v=1.8.0'
import React from 'react'
//import ReactDOM from "react-dom";
import App from './App'
import ThemeContextProvider from 'util/hooks/ThemeContext';
import reactDom from 'react-dom';

reactDom.render(
  <ThemeContextProvider>
    <App />
  </ThemeContextProvider>,
  document.getElementById("root")
);
